import {  BookingPaymentValidity, CarePlanBillingValidity, CarePlanCustomerValidity, CarePlanPaymentBankDetailsValidity, CarePlanPlanDetailsValidity, LandlordValidity, OtherValidity, PropertyValidity, RelatedValidity } from "@utils/ComplexTypes";
import * as StateInterface from "./interface";
export * from "./interface";

const carePlanBillingMethodValidity = (): CarePlanBillingValidity => ({
  CarePlanBillingAddressPropertyValid: false,
  CarePlanBillingAddressBusinessNameValid: false,
  CarePlanBillingAddressCityValid: false,
  CarePlanBillingAddressCountryValid: false,
  CarePlanBillingAddressLocalityValid: false,
  CarePlanBillingAddressPostcodeValid: false,
  CarePlanBillingAddressStreetValid: false,
  CarePlanBillingContactEmailValid: false,
  CarePlanBillingContactFirstNameValid: false,
  CarePlanBillingContactLandlineValid: false,
  CarePlanBillingContactLastNameValid: false,
  CarePlanBillingContactMobileValid: false,
  CarePlanBillingContactRelationshipValid: false,
  CarePlanBillingContactTitleValid: false,
  CarePlanBillingMethodPaymentTypeValid: false,
  CarePlanBillingAddressValid: false,
  CarePlanBillingContactValid: false,
  CarePlanBillingMethodValid: false,
  CarePlanBillingValid: false,
});

const carePlanCustomerValidity = (): CarePlanCustomerValidity => ({
  CarePlanCustomerAddressPropertyValid: false,
  CarePlanCustomerAddressBusinessNameValid: false,
  CarePlanCustomerAddressCityValid: false,
  CarePlanCustomerAddressCountryValid: false,
  CarePlanCustomerAddressLocalityValid: false,
  CarePlanCustomerAddressPostcodeValid: false,
  CarePlanCustomerAddressStreetValid: false,
  CarePlanCustomerContactEmailValid: false,
  CarePlanCustomerContactFirstNameValid: false,
  CarePlanCustomerContactLandlineValid: false,
  CarePlanCustomerContactLastNameValid: false,
  CarePlanCustomerContactMobileValid: false,
  CarePlanCustomerContactRelationshipValid: false,
  CarePlanCustomerContactTitleValid: false,
  CarePlanCustomerAddressValid: false,
  CarePlanCustomerContactValid: false,
  CarePlanCustomerValid: false,
});

const carePlanPlanDetailsValidity = (): CarePlanPlanDetailsValidity => ({
  CarePlanPlanDetailsAddressPropertyValid: false,
  CarePlanPlanDetailsAddressBusinessNameValid: false,
  CarePlanPlanDetailsAddressCityValid: false,
  CarePlanPlanDetailsAddressCountryValid: false,
  CarePlanPlanDetailsAddressLocalityValid: false,
  CarePlanPlanDetailsAddressPostcodeValid: false,
  CarePlanPlanDetailsAddressStreetValid: false,
  CarePlanPlanDetailsBoilerBoilerInstallationDateValid: false,
  CarePlanPlanDetailsBoilerBoilerLastServicedDateValid: false,
  CarePlanPlanDetailsBoilerBoilerManufacturersValid: false,
  CarePlanPlanDetailsBoilerBoilerModelValid: false,
  CarePlanPlanDetailsBoilerHeatingTypesValid: false,
  CarePlanPlanDetailsOfferOfferReasonValid: false,
  CarePlanPlanDetailsOfferOfferTypeValid: false,
  CarePlanPlanDetailsPlanOptionsBillingFrequencyValid: false,
  CarePlanPlanDetailsPlanOptionsDurationValid: false,
  CarePlanPlanDetailsPlanOptionsExcessValid: false,
  CarePlanPlanDetailsPlanOptionsPlanTypeValid: false,
  CarePlanPlanDetailsPropertyBathroomsValid: false,
  CarePlanPlanDetailsPropertyBedroomsValid: false,
  CarePlanPlanDetailsPropertyBuildingTypesValid: false,
  CarePlanPlanDetailsPropertyExternalDoorsValid: false,
  CarePlanPlanDetailsPropertyGasAppliancesValid: false,
  CarePlanPlanDetailsPropertyGasSafetyDueDateValid: false,
  CarePlanPlanDetailsPropertyRadiatorsValid: false,
  CarePlanPlanDetailsAddressValid: false,
  CarePlanPlanDetailsBoilerValid: false,
  CarePlanPlanDetailsOfferValid: false,
  CarePlanPlanDetailsPlanOptionsValid: false,
  CarePlanPlanDetailsPropertyValid: false,
  CarePlanPlanDetailsValid: false,
  CarePlanPlanDetailsOfferPromoCodeValid: false,
});

const carePlanPaymentBankDetailsValidity = (): CarePlanPaymentBankDetailsValidity => ({
  CarePlanPaymentBankDetailsAccountNumberValid: false,
  CarePlanPaymentBankDetailsBankNameValid: false,
  CarePlanPaymentBankDetailsSortCodeValid: false,
  CarePlanPaymentBankDetailsValid: false,
});

const relatedValidity = (): RelatedValidity => ({
  RelatedAddressPropertyValid: false,
  RelatedAddressBusinessNameValid: false,
  RelatedAddressCityValid: false,
  RelatedAddressCountryValid: false,
  RelatedAddressLocalityValid: false,
  RelatedAddressPostcodeValid: false,
  RelatedAddressStreetValid: false,
  RelatedContactEmailValid: false,
  RelatedContactFirstNameValid: false,
  RelatedContactLandlineValid: false,
  RelatedContactLastNameValid: false,
  RelatedContactMobileValid: false,
  RelatedContactRelationshipValid: false,
  RelatedContactTitleValid: false,
  RelatedAddressValid: false,
  RelatedContactValid: false,
  RelatedValid: false,
});

const propertyValidity = (): PropertyValidity => ({
  PropertyAddressPropertyValid: false,
  PropertyAddressBusinessNameValid: false,
  PropertyAddressCityValid: false,
  PropertyAddressCountryValid: false,
  PropertyAddressLocalityValid: false,
  PropertyAddressPostcodeValid: false,
  PropertyAddressStreetValid: false,
  PropertyContactEmailValid: false,
  PropertyContactFirstNameValid: false,
  PropertyContactLandlineValid: false,
  PropertyContactLastNameValid: false,
  PropertyContactMobileValid: false,
  PropertyContactRelationshipValid: false,
  PropertyContactTitleValid: false,
  PropertyAddressValid: false,
  PropertyContactValid: false,
  PropertyValid: false,
});

const otherValidity = (): OtherValidity => ({
  OtherAddressPropertyValid: false,
  OtherAddressBusinessNameValid: false,
  OtherAddressCityValid: false,
  OtherAddressCountryValid: false,
  OtherAddressLocalityValid: false,
  OtherAddressPostcodeValid: false,
  OtherAddressStreetValid: false,
  OtherAddressValid: false,
  OtherValid: false,
});

const landlordValidity = (): LandlordValidity => ({
  LandlordAddressPropertyValid: false,
  LandlordAddressBusinessNameValid: false,
  LandlordAddressCityValid: false,
  LandlordAddressCountryValid: false,
  LandlordAddressLocalityValid: false,
  LandlordAddressPostcodeValid: false,
  LandlordAddressStreetValid: false,
  LandlordContactEmailValid: false,
  LandlordContactFirstNameValid: false,
  LandlordContactLandlineValid: false,
  LandlordContactLastNameValid: false,
  LandlordContactMobileValid: false,
  LandlordContactRelationshipValid: false,
  LandlordContactTitleValid: false,
  LandlordAddressValid: false,
  LandlordContactValid: false,
  LandlordValid: false,
});

export const bookingPaymentValidity = (): BookingPaymentValidity => ({
  BookingPaymentAddressPropertyValid: false,
  BookingPaymentAddressBusinessNameValid: false,
  BookingPaymentAddressCityValid: false,
  BookingPaymentAddressCountryValid: false,
  BookingPaymentAddressLocalityValid: false,
  BookingPaymentAddressPostcodeValid: false,
  BookingPaymentAddressStreetValid: false,
  BookingPaymentContactEmailValid: false,
  BookingPaymentContactFirstNameValid: false,
  BookingPaymentContactLandlineValid: false,
  BookingPaymentContactLastNameValid: false,
  BookingPaymentContactMobileValid: false,
  BookingPaymentContactRelationshipValid: false,
  BookingPaymentContactTitleValid: false,
  BookingPaymentAddressValid: false,
  BookingPaymentContactValid: false,
  BookingPaymentValid: false,
  BookingPaymentMethodCardAgreedValid: false,
  BookingPaymentMethodCompanyRegistrationValid: false,
  BookingPaymentMethodCompanyRegistrationAccepted: false,
  BookingPaymentMethodIsRequisition: false,
  BookingPaymentMethodPaymentMethodsValid: false,
  BookingPaymentMethodPaymentRequisitionsValid: false,
  BookingPaymentMethodPaymentValid: false,
  BookingPaymentMethodCardSecuredValid: false,
});

export const stateTemplate: StateInterface.TemplateSTATE = () => ({
  Account: undefined,
  BOOKING_DATA_SYNC: [],
  BookingFailed: undefined,
  BookingFormLoaded: false,
  CacheLoaded: false,
  CacheLoading: false,
  CachingStarted: false,
  CallApprentice: 0,
  CallBooking: 0,
  CallCallBack: 0,
  CallDateTimeCreated: undefined,
  CallEngineer: 0,
  CallEngineerMessage: 0,
  ...bookingPaymentValidity(),
  ...carePlanBillingMethodValidity(),
  ...carePlanCustomerValidity(),
  ...carePlanPaymentBankDetailsValidity(),
  ...carePlanPlanDetailsValidity(),
  CallEngineerRecruit: 0,
  CallFailed: 0,
  CallGoBack: 0,
  CallHAUKAttempt: 0,
  CallHAUKHotLead: 0,
  CallHAUKOnly: 0,
  CallHAUKSale: 0,
  CallHoax: 0,
  CallHomeserve: undefined,
  CallHomeserveFailedReasonId: undefined,
  CallHomeserveRevertReasonId: undefined,
  CallId: 0,
  CallInsuranceQuantity: undefined,
  CallInsuranceTypeId: undefined,
  CallNotes: "",
  CallOther: 0,
  CallOtherPhoneId: 0,
  CallQuote: 0,
  CallReducedRate: 0,
  CallStarted: false,
  CallSubReason: undefined,
  CallTypeGroup: undefined,
  CallTypeId: undefined,
  CarePlanActive: false,
  CarePlanBillingPaymentMethodValid: false,
  CarePlanPaymentValid: false,
  CarePlanRenewal: undefined,
  CarePlanStatus: undefined,
  CarePlanType: undefined,
  Charge: undefined,
  ChargeCallTypeId: 0,
  ChargeCardRequired: 0,
  ChargeCommercialSelectedIndex: 0,
  ChargeDateTimeRequired: undefined,
  ChargeEncryptedCardNumber: "",
  ChargeIsCommercial: false,
  ChargeIsRequisition: false,
  ChargeIsVATInclusive: false,
  ChargeJobTypeCode: "",
  ChargePostcode: "",
  ChargePrice: 0.0,
  ChargePriceAdj: 0.0,
  ChargePromoDiscountDetails: "",
  ChargePromoDiscountId: 0,
  ChargeQuantity: 0,
  ChargeRate: 0.0,
  ChargeRateAdj: 0.0,
  ChargeRateOriginalPrice: 0.0,
  ChargeRateOriginalRate: 0.0,
  ChargeRatePeriod: 0,
  ChargeRateReductionDiscountId: 0,
  ChargeRateSubPeriod: 0,
  ChargeRateSubRate1: 0.0,
  ChargeRateSubRate2: 0.0,
  ChargeRateSubRate3: 0.0,
  ChargeRateSubTime: "",
  ChargeRateSubTimely: "",
  ChargeRateTime: "",
  ChargeRateTimely: "",
  ChargeReductionAdjustmentRate: 0.0,
  ChargeReductionDiscount: 0.0,
  ChargeReductionDiscountDetails: "",
  ChargeReductionIsPercentage: false,
  ChargeReductionMaximumReducedRate: 0.0,
  ChargeReductionOriginalMaximumReducedRate: 0.0,
  ChargeRequisitionTypeId: 0,
  ChargeTrace: "",
  CompletedJob: 0,
  Conditions: undefined,
  Discount: undefined,
  Emergency: false,
  FormLocked: false,
  HomeLoading: false,
  InvalidEmailAddresses: [],
  IsAddressSelectedOnce: false,
  IsAGoBack: undefined,
  IsAQuote: false,
  IsAuthenticated: false,
  IsCapped: false,
  IsFirstStageFailureForbidden: false,
  IsFixedPrice: false,
  ForceHouseIconCount: false,
  JobAddedToMIS: false,
  JobAllocatedBy: 0,
  JobAmountPaid: 0,
  JobAppointmentTimeTypeId: undefined,
  JobAreaNumber: 0,
  JobBoilerAge: undefined,
  JobBoilerInWorkingOrder: undefined,
  JobBookingSourceId: 0,
  JobCancelCode: 0,
  JobChargeId: undefined,
  JobChequeCardExpiry: undefined,
  JobChequeCardNumber: "",
  JobCompanyRegistrationName: undefined,
  JobCompanyRegistrationNumber: undefined,
  JobComplAccountType: "",
  JobComplCallTypeId: 0,
  JobComplJobTypeCode: "",
  JobComplTradeCode: "",
  JobCounty: "",
  JobCustomerCLI: "",
  JobCustomerForename: "",
  JobCustomerReference: "",
  JobCustomerSurname: "",
  JobCustomerTitle: "",
  JobDateReceived: undefined,
  JobDateTimeAllocated: undefined,
  JobDateTimeCancelled: undefined,
  JobDateTimeCommitted: undefined,
  JobDateTimeCompleted: undefined,
  JobDateTimeEstimated: undefined,
  JobDateTimeFailed: undefined,
  JobDateTimeLatestArrival: undefined,
  JobDateTimeOriginalRequired: undefined,
  JobDateTimeReceived: undefined,
  JobDateTimeRequired: undefined,
  JobDateTimeStatus: undefined,
  JobDateTimeUpdated: undefined,
  JobDetailedSource: "",
  JobDiscountId: 0,
  JobDuplicateJobId: 0,
  JobEmailAddress: "",
  JobEngineerId: 0,
  JobEstimatedHours: undefined,
  JobFailedId: 0,
  JobGCLID: undefined,
  JobGeneralStr1: "",
  JobGeneralStr4: "",
  JobGoBackJobId: 0,
  JobHaveOfferedServiceAgreement: false,
  JobHaveReadTandCs: false,
  JobId: -1,
  JobIsAdvanceBooking: false,
  JobIsAHouse: false,
  JobIsAppointmentFixed: false,
  JobIsCallMeBack: false,
  JobIsCommercial: false,
  JobIsCompetitorReferral: undefined,
  JobIsDifferentGoBackEngineer: false,
  JobIsDiscounted: false,
  JobIsInterestedInCareClub: undefined,
  JobIsLandlord: false,
  JobIsOkToMarket: false,
  JobIsPerHalfHour: false,
  JobIsPropertyOwner: false,
  JobIsQuote: false,
  JobIsTenant: false,
  JobLabourValue: 0,
  JobLocality: "",
  JobMaterialsValue: 0,
  JobNotes: undefined,
  JobOrganisation: "",
  JobOriginalTimeRequirementTypeId: undefined,
  JobPartsSupplied: undefined,
  JobPaymentMethodId: 0,
  JobPaymentTaken: false,
  JobPaymentType: "",
  JobPostcode: "",
  JobPostcodeArea: "",
  JobPostcodeDistrict: "",
  JobPostcodeSector: "",
  JobPrice1: 0,
  JobPrice2: 0,
  JobPrice3: 0,
  JobProperty: "",
  JobRate1: 0,
  JobRate2: 0,
  JobRate3: 0,
  JobReviewsFetched: false,
  JobServiceAgreementDeclinedId: 0,
  JobServiceAgreementId: undefined,
  JobSoldBy: 0,
  JobStatusId: 0,
  JobStreet: "",
  JobSundriesValue: 0,
  JobTelephoneFax: "",
  JobTelephoneLandline: "",
  JobTelephoneMobile: "",
  JobTimeRequirementTypeId: 0,
  JobTotalCharges: 0,
  JobTotalPayments: 0,
  JobTown: "",
  JobTradeCode: "",
  JobTypeCode: "",
  JobUnconvertedFailedCode: 0,
  JobVATValue: 0,
  JobWasCancelled: false,
  JobWasCardReceived: false,
  JobWasFailed: false,
  LastJob: [],
  LoadDate: undefined,
  NavMenuCollapsed: true,
  News: "",
  NotesAppointment: undefined,
  NotesCaller: undefined,
  NotesCarePlan: undefined,
  NotesFailed: undefined,
  NotesJob: undefined,
  NotesLandlord: undefined,
  NotesOther: undefined,
  NotesParking: undefined,
  NotesPrevious: undefined,
  NotesRelated: undefined,
  PaymentMethods: [],
  PaymentRequisitions: [
    {
      id: 1,
      name: "E-Mail",
    },
    // {   not used anymore
    //   id: 2,
    //   name: "Fax"
    // }
  ],
  PossibleCC: false,
  PreDiscountCharge: 0,
  PriceCap: 110,
  PossibleCaravanSite: false,
  ProblemComboJobValid: false,
  ProblemCoverageValid: false,
  PromoCodeApplied: false,
  PromoCodeValid: false,
  ...propertyValidity(),
  ...relatedValidity(),
  ...otherValidity(),
  ...landlordValidity(),
  RequiredOption1Answer: "",
  RequiredOption1Required: false,
  RequiredOption1Valid: false,
  RequiredOption2Answer: "",
  RequiredOption2Required: false,
  RequiredOption2Valid: false,
  RequiredOption3Answer: "",
  RequiredOption3Required: false,
  RequiredOption3Valid: false,
  RequiredOption4Answer: "",
  RequiredOption4Required: false,
  RequiredOption4Valid: false,
  RequiredOption5Answer: "",
  RequiredOption5Required: false,
  RequiredOption5Valid: false,
  RequiredOption6Answer: "",
  RequiredOption6Required: false,
  RequiredOption6Valid: false,
  RequiredOption7Answer: "",
  RequiredOption7Required: false,
  RequiredOption7Valid: false,
  RequiredOption8Answer: "",
  RequiredOption8Required: false,
  RequiredOption8Valid: false,
  RequiredOption9Answer: "",
  RequiredOption9Required: false,
  RequiredOption9Valid: false,
  RequiredOption10Answer: "",
  RequiredOption10Required: false,
  RequiredOption10Valid: false,
  RequiredOptionsChanged: false,
  RequiredOptionsValid: false,
  RestrictionExpiresIn30Days: -1,
  SavingJob: false,
  Script: undefined,
  ServiceAgreementsAvailability: [],
  SquareCardCVVValid: false,
  SquareCardNumberValid: false,
  SquareExpirationValid: false,
  Step1_1Valid: false,
  Step1_2Valid: false,
  Step1_3Valid: false,
  Step1_4Valid: false,
  Step2_1Valid: false,
  Step2_2Valid: false,
  Step2_3Valid: false,
  Step2_3Clicked: false,
  Step3_1Valid: true,
  Step3_2Valid: false,
  Step3_3Complete: false,
  Step3_3Valid: false,
  Step3_4Valid: false,
  TimeRequirementType: undefined,
  UserId: -1,
  UsersStatistics: [],
  UsersStatisticsYesterday: [],
  ValidEmailAddresses: [],
  VATRate: 1.2,
});
